var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingBag4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 5.8V6.81333H6.0701C4.82351 6.81333 3.85977 7.8844 4.0168 9.0953L5.33095 19.2286C5.46225 20.2411 6.34194 21 7.38425 21H16.6158C17.6581 21 18.5377 20.2411 18.669 19.2286L19.9832 9.0953C20.1402 7.8844 19.1765 6.81333 17.9299 6.81333H15.75V5.8C15.75 3.70132 14.0711 2 12 2C9.92893 2 8.25 3.70132 8.25 5.8ZM12 3.52C13.2426 3.52 14.25 4.54079 14.25 5.8V6.81333H9.75V5.8C9.75 4.54079 10.7574 3.52 12 3.52ZM11 10.4595C10.8619 10.4595 10.75 10.5684 10.75 10.7027V12.3199H15C15.5523 12.3199 16 12.7438 16 13.2666V17.0533C16 17.5762 15.5523 18 15 18H9C8.44772 18 8 17.5762 8 17.0533V13.2666C8 12.7438 8.44772 12.3199 9 12.3199H9.25V10.7027C9.25 9.76233 10.0335 9 11 9H13C13.9665 9 14.75 9.76233 14.75 10.7027C14.75 11.1057 14.4142 11.4324 14 11.4324C13.5858 11.4324 13.25 11.1057 13.25 10.7027C13.25 10.5684 13.1381 10.4595 13 10.4595H11Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag4);
export default __webpack_public_path__ + "static/media/shopping-bag-4.18b997044bffbbc5c530ca4f41280ec8.svg";
export { ForwardRef as ReactComponent };